module.exports = __webpack_public_path__ + "static/img/img-instmng-empty-hospital.35ec70e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instmng/instlist/img-instmng-empty-hospital.png
// module id = LUIE
// module chunks = 1